import moment from "moment";
import { construirHojaTabla, descargarLibro, texto, numero } from "../../../../Components/ExcelTablaReporte";

export const nombreCompleto = (u) => (u ? [u.nombre, u.apellidoPaterno, u.apellidoMaterno].filter(Boolean).join(" ") : "");

export const formatoMinutos = (minutos) => {
  const total = Math.max(0, Math.round(minutos || 0));
  return `${String(Math.floor(total / 60)).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
};

const resumenPor = (paros, clave, etiqueta) => {
  const mapa = new Map();
  paros.forEach((p) => {
    const k = clave(p);
    const previo = mapa.get(k) || { ...etiqueta(p), minutos: 0, paros: 0 };
    previo.minutos += p.minutos;
    previo.paros += 1;
    mapa.set(k, previo);
  });
  const total = paros.reduce((acc, p) => acc + p.minutos, 0);
  let acumulado = 0;
  return [...mapa.values()]
    .sort((a, b) => b.minutos - a.minutos)
    .map((fila) => {
      acumulado += fila.minutos;
      return {
        ...fila,
        porcentaje: total ? Math.round((fila.minutos / total) * 1000) / 10 : 0,
        porcentajeAcumulado: total ? Math.round((acumulado / total) * 1000) / 10 : 0,
      };
    });
};

export const resumirParos = (paros = []) => ({
  totalMinutos: paros.reduce((acc, p) => acc + p.minutos, 0),
  porOrigen: resumenPor(paros, (p) => p.origen, (p) => ({ origen: p.origen })),
  porCodigo: resumenPor(paros, (p) => p.codigo, (p) => ({ codigo: p.codigo, origen: p.origen, motivo: p.motivo })),
});

const tablaDetalle = (paros) => {
  const columnas = [
    { titulo: "Fecha", tipo: "texto", ancho: 12 },
    { titulo: "Hora de paro", tipo: "texto", ancho: 12 },
    { titulo: "Hora de arranque", tipo: "texto", ancho: 14 },
    { titulo: "Tiempo muerto (hh:mm)", tipo: "texto", ancho: 14 },
    { titulo: "Código", tipo: "texto", ancho: 9 },
    { titulo: "Origen", tipo: "texto", ancho: 18 },
    { titulo: "Motivo", tipo: "texto", ancho: 36 },
    { titulo: "Registró", tipo: "texto", ancho: 28 },
    { titulo: "Observaciones", tipo: "texto", ancho: 36 },
  ];
  const filas = paros.map((p) => [
    texto(moment(p.fechaParo).format("DD/MM/YYYY")),
    texto(moment(p.fechaParo).format("HH:mm")),
    texto(p.fechaArranque ? moment(p.fechaArranque).format(moment(p.fechaArranque).isSame(p.fechaParo, "day") ? "HH:mm" : "DD/MM HH:mm") : "Abierto"),
    texto(formatoMinutos(p.minutos)),
    texto(p.codigo),
    texto(p.origen),
    texto(p.motivo),
    texto(nombreCompleto(p.usuarioId)),
    texto(p.observaciones || ""),
  ]);
  return { columnas, filas, totales: columnas.map(() => null) };
};

const tablaResumen = (filas, conCodigo) => {
  const columnas = [
    ...(conCodigo ? [{ titulo: "Código", tipo: "texto", ancho: 9 }] : []),
    { titulo: "Origen", tipo: "texto", ancho: 18 },
    ...(conCodigo ? [{ titulo: "Motivo", tipo: "texto", ancho: 36 }] : []),
    { titulo: "Paros", tipo: "numero", ancho: 8 },
    { titulo: "Tiempo muerto (hh:mm)", tipo: "texto", ancho: 14 },
    { titulo: "Minutos", tipo: "numero", ancho: 10 },
    { titulo: "%", tipo: "numero", ancho: 8 },
    { titulo: "% acumulado", tipo: "numero", ancho: 12 },
  ];
  const datos = filas.map((f) => [
    ...(conCodigo ? [texto(f.codigo)] : []),
    texto(f.origen),
    ...(conCodigo ? [texto(f.motivo)] : []),
    numero(f.paros),
    texto(formatoMinutos(f.minutos)),
    numero(f.minutos),
    numero(f.porcentaje),
    numero(f.porcentajeAcumulado),
  ]);
  return { columnas, filas: datos, totales: columnas.map(() => null) };
};

export const descargarTiemposMuertosExcel = ({ paros, empresaNombre, descripcion, nombreArchivo }) => {
  const resumen = resumirParos(paros);
  const opciones = (titulo) => ({ titulo, empresaNombre, descripcionFiltros: `${descripcion} · Total ${formatoMinutos(resumen.totalMinutos)}` });
  descargarLibro(
    [
      { nombre: "Tiempos muertos", hoja: construirHojaTabla(tablaDetalle(paros), opciones("Reporte de tiempos muertos (MPP-FT-49)")) },
      { nombre: "Por origen", hoja: construirHojaTabla(tablaResumen(resumen.porOrigen, false), opciones("Tiempo muerto por origen")) },
      { nombre: "Por codigo", hoja: construirHojaTabla(tablaResumen(resumen.porCodigo, true), opciones("Tiempo muerto por código")) },
    ],
    nombreArchivo
  );
};
